var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13092 10.7329C9.08063 10.7997 9.01542 10.854 8.94045 10.8914C8.86549 10.9288 8.78282 10.9482 8.69901 10.9482C8.61519 10.9482 8.53253 10.9288 8.45756 10.8914C8.3826 10.854 8.31739 10.7997 8.2671 10.7329L6.10755 7.86124C6.0474 7.78124 6.01076 7.68612 6.00176 7.58652C5.99275 7.48693 6.01173 7.3868 6.05657 7.29736C6.10141 7.20792 6.17034 7.1327 6.25563 7.08012C6.34092 7.02755 6.4392 6.9997 6.53946 6.9997H10.8586C10.9588 6.9997 11.0571 7.02755 11.1424 7.08012C11.2277 7.1327 11.2966 7.20792 11.3414 7.29736C11.3863 7.3868 11.4053 7.48693 11.3963 7.58652C11.3873 7.68612 11.3506 7.78124 11.2905 7.86124L9.13092 10.7329Z",
    fill: "#ACACAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M8.28805 14.7311C12.1643 14.7311 15.3066 11.7176 15.3066 8.0003C15.3066 4.283 12.1643 1.26953 8.28805 1.26953C4.41183 1.26953 1.26953 4.283 1.26953 8.0003C1.26953 11.7176 4.41183 14.7311 8.28805 14.7311Z",
    stroke: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCircle);
export default __webpack_public_path__ + "static/media/downCircle.66cb4a1cf25590cf99b3f999f18272a1.svg";
export { ForwardRef as ReactComponent };